<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="installer"
      data-test-id="installer"
      @click="$emit('installer-closed')"
    >
      <EIconButton
        data-test-id="installer-close"
        class="installer__close"
        icon="close"
        size="l"
        @click="$emit('installer-closed')"
      />
      <div>
        <LogoWhite class="installer__logo" />
        <ol class="installer__points">
          <li
            v-for="translation in browserTranslations"
            :key="translation"
            v-safe-html="$t(translation)"
            class="installer__point"
          />
        </ol>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';

import EIconButton from '~~/common/vue/components/icon-button';
import LogoWhite from '~~/common/vue/components/logos/logo-ecosia-white.svg';

const BROWSER_INSTALL_TRANSLATIONS = {
  firefox: [
    'common.install.overlay.firefox.point1',
    'common.install.overlay.firefox.point2',
    'common.install.overlay.firefox.point3',
  ],
  ie: [
    'common.install.overlay.ie.point1',
    'common.install.overlay.ie.point2',
    'common.install.overlay.ie.point3',
    'common.install.overlay.ie.point4',
  ],
  edge: [
    'common.install.overlay.edge.point1',
    'common.install.overlay.edge.point2',
    'common.install.overlay.edge.point3',
    'common.install.overlay.edge.point4',
    'common.install.overlay.edge.point5',
    'common.install.overlay.edge.point6',
  ],
};

export default {
  name: 'Install',
  components: {
    EIconButton,
    LogoWhite,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('browser', {
      browserName: 'name',
    }),
    browserTranslations() {
      const browserName = this.browserName || '';
      return BROWSER_INSTALL_TRANSLATIONS[browserName.toLowerCase()];
    },
  },
};
</script>

<style lang="scss" scoped>
.installer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: $z-index-overlay;
  overflow: auto;
  color: $white;
  background-color: rgba($black, $opacity-1l);
  display: flex;
  justify-content: center;
  font-size: $font-1l;
  box-sizing: border-box;
  padding: $space-l;

  @include tablet {
    padding: $space-2l;
    font-size: $font-2l;
  }

  @include desktop {
    font-size: $font-3l;
  }
}

.installer__logo {
  display: block;
  margin: 115px auto $space-1l;
  width: 110px;
  height: 82px;

  @include tablet {
    margin-bottom: $space-4l;
    width: 159px;
    height: 117px;
  }
}

.installer__close {
  position: absolute;
  top: $space-l;
  right: $space-l;
  color: $gray-30;

  &:active,
  &:hover,
  &:focus {
    color: $white;
  }
}

.installer__points {
  text-align: left;
  margin: 0;
  padding-left: $font-m;
}

.installer__point {
  margin: 0 0 $space-s;
}

.install__close {
  transform: scale($scale-4l);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $timing-s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<docs>
```js
let active = false;

<div>
  <install
    :active="active"
    @closeInstaller="active = false"
  />
  <button type="button" @click="active = true">Show</button>
</div>
```
</docs>
